import React, { useEffect, useRef, useState } from 'react'
import FeatureLayer from "@arcgis/core/layers/FeatureLayer";
import Query from "@arcgis/core/rest/support/Query";
import { useSelector } from 'react-redux';
import Select from "react-select";
import Graphic from "@arcgis/core/Graphic";
import GraphicsLayer from "@arcgis/core/layers/GraphicsLayer";
import { ToastContainer, toast } from 'react-toastify';
import Loader from "../../componets/Loader";
import CreatableSelect from 'react-select/creatable';
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
const layersData = [
   "Administrative Boundaries",
   "Agriculture",
   "Climate",
   "Cooperative Societies",
   "Cultural",
   "Education",
   "Election",
   "Emergency Services",
   "Excise",
];

function GisQuery({ onLayerSelect, view }) {
   const [districts, setDistricts] = useState([]);
   const [districtName, setDistrictName] = useState('');
   const [ulbs, setUlbs] = useState([]);
   const [ulbName, setUlbName] = useState('');
   const [selectedDistrict, setSelectedDistrict] = useState("");
   const [selectedLayer, setSelectedLayer] = useState("");
   const [selectedUlb, setSelectedUlb] = useState("");
   const [fields, setFields] = useState([]);
   const [fieldValues, setFieldValues] = useState([]);
   const [selectedField, setSelectedField] = useState('');
   const [selectedFieldValue, setSelectedFieldValue] = useState('');
   const [geometry, setGeometory] = useState();
   const [plotData, setPlotData] = useState([]);
   const [plotCount, setPlotCount] = useState();
   const [floorData, setFloorData] = useState([]);
   const [floorCount, setFloorCount] = useState();
   const [isLoader, setIsSetLoader] = useState(false);
   const { isTheme } = useSelector((state) => state.currentStage)
   const authData = useSelector(state => state.authToken.authData);
   const [selectedPlotSizeCondition, setSelectedPlotSizeCondition] = useState(null);
   const [plotSizeGraphicsLayer, setPlotSizeGraphicsLayer] = useState(null);
   const [selectedFloorCondition, setSelectedFloorCondition] = useState(null);
   const [selectedOperator, setSelectedOperator] = useState(null);
   const [selectedPlotSizeValue, setSelectedPlotSizeValue] = useState(null);
   const [expanded, setExpanded] = useState({});
   const [checked, setChecked] = useState({});
   const [search, setSearch] = useState("");
   const [activeSelect, setActiveSelect] = useState("area");

   // const layers = [
   //    { name: "Roads", id: 45, outFields: ["*"] },
   //    { name: "Rivers", id: 69, outFields: ["ulb_cd ", "name", "area", "wardno"] },
   //    { name: "Railway", id: 56, outFields: ["ulb_cd ", "type", "dist_cd", "wardno"] },
   //    { name: "Important Land Marks", id: 79, outFields: ["ulb_cd", "name", "type"] },
   //    { name: "property", id: 14, outFields: ["*"] },
   //     { name: "view_mis_data", id: 97, outFields: ["*"] }, // Added new layer

   // ];

   const layers = [
      // { name: "Roads", id: 45, outFields: ["*"], service: "urbangis_temp" },
      // { name: "Rivers", id: 69, outFields: ["ulb_cd ", "name", "area", "wardno"], service: "urbangis_temp" },
      // { name: "Railway", id: 56, outFields: ["ulb_cd ", "type", "dist_cd", "wardno"], service: "urbangis_temp" },
      // { name: "Important Land Marks", id: 79, outFields: ["ulb_cd", "name", "type"], service: "urbangis_temp" },
      // { name: "property", id: 14, outFields: ["*"], service: "urbangis_temp" },
      { name: "Property Data", id: 97, outFields: ["*"], service: "view_mis_data" }, // Added with different service
   ];



   useEffect(() => {
      const fetchDistrictCodes = async () => {
         const url =
            "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5/query?where=1=1&outFields=dist_cd&returnGeometry=false&returnDistinctValues=true&f=geojson";
         try {
            const response = await fetch(url);
            const data = await response.json();
            if (data.features) {
               return data.features.map((feature) => feature.properties.dist_cd);
            }
         } catch (error) {
            console.log("Error fetching district codes:", error);
         }
         return [];
      };

      const loadDistricts = async () => {
         const distCodes = await fetchDistrictCodes();
         if (distCodes.length === 0) {
            console.log("No district codes found");
            return;
         }
         const districtLayer = new FeatureLayer({
            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/3"
         });
         const query = new Query();
         query.returnGeometry = true;
         query.outFields = ["dist_cd", "districtname"];
         query.where = `dist_cd IN (${distCodes.map((code) => `'${code}'`).join(",")})`;
         query.returnDistinctValues = true;
         try {
            const response = await districtLayer.queryFeatures(query);
            const districtNames = response.features.map(f => ({
               id: f.attributes.dist_cd,
               label: f.attributes.districtname
            }));
            districtNames.sort((a, b) => a.label.localeCompare(b.label));
            setDistricts(districtNames);
         } catch (error) {
            console.log("Error loading districts:", error);
         }
      };

      const handleAdminUser = async () => {
         const userDistricts = [{
            id: authData?.DistrictCode,
            label: authData?.DistrictName
         }];
         setDistricts(userDistricts);
         setDistrictName(authData?.DistrictName);
         setSelectedDistrict(authData?.DistrictCode);

         const userUlbs = [{
            id: authData?.Ulb_Code,
            label: authData?.UlbName
         }];
         setUlbs(userUlbs);
         setUlbName(authData?.UlbName);
         setSelectedUlb(authData?.Ulb_Code);

         // ⬇️ Ensure district zoom finishes before ULB zoom
         await zoomToFeature(authData?.DistrictCode, "dist_cd", "3");
         await zoomToFeature(authData?.Ulb_Code, "ulb_cd", "5");
      };

      if (authData?.UserType === "User" || authData?.UserType === "districtuser") {
         handleAdminUser();
      } else {
         loadDistricts();
      }
      // loadDistricts();
   }, []);


   const handleDistrictChange = (selectedOption) => {
      setDistrictName(selectedOption?.label)
      const selected = selectedOption?.value;
      if (!selected) return;
      setSelectedDistrict(selected);
      setSelectedUlb("");
      setUlbs([]);
      setSelectedLayer("");
      setSelectedField("");
      setFields([]);
      setSelectedFieldValue("");
      setFieldValues([]);
      loadUlbs(selected);
      zoomToFeature(selected, "dist_cd", "3");
   };

   const loadUlbs = async (district) => {
      try {
         const ulbLayer = new FeatureLayer({
            url: "https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/5"
         });
         const ulbQuery = new Query();
         ulbQuery.where = `dist_cd = '${district}'`
         ulbQuery.outFields = ["ulb_cd", "name"];
         ulbQuery.returnDistinctValues = true;
         const ulbResponse = await ulbLayer.queryFeatures(ulbQuery);
         const ulbNames = ulbResponse.features.map(f => { return { "id": f?.attributes.ulb_cd, "lable": f?.attributes.name } });
         setUlbs(ulbNames);

      } catch (error) {
         console.log("Error loading ULBs:", error);
      }

   };

   const handleUlbChange = async (selectedOption) => {
      setUlbName(selectedOption?.label)
      const selectedUlb = selectedOption?.value
      if (!selectedUlb) return;
      setSelectedUlb(selectedUlb);
      setSelectedLayer("");
      setSelectedField("");
      setFields([]);
      setSelectedFieldValue("");
      setFieldValues([]);
      if (selectedUlb) {
         zoomToFeature(selectedUlb, "ulb_cd", "5");
      }
   };

   const toggleExpand = (layer) => {
      setExpanded((prev) => ({ ...prev, [layer]: !prev[layer] }));
   };

   const toggleCheck = (layer) => {
      setChecked((prev) => ({ ...prev, [layer]: !prev[layer] }));
   };

   const filteredLayers = layersData.filter((layer) =>
      layer.toLowerCase().includes(search.toLowerCase())
   );


   //layers
   // const handleLayerChange = async (selectedOption) => {
   //    try {
   //       view.graphics.removeAll();
   //       const selected = selectedOption?.label;
   //       setSelectedLayer(selected);
   //       setSelectedField("");
   //       setFields([]);
   //       setSelectedFieldValue("");
   //       setFieldValues([]);
   //       const layerDetails = layers.find((layer) => layer.name === selected);
   //       if (!layerDetails) {
   //          console.log("Layer details not found for the selected option.");
   //          // setBufferFeatures([]);
   //          return;
   //       }
   //       const layer = new FeatureLayer({
   //          url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
   //       });

   //       const query = new Query();
   //       query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}'`;
   //       //query.where = `dist_cd = '${selectedDistrict}'`;
   //       query.returnGeometry = true;
   //       query.outFields = ["*"]; // Fetch all fields

   //       const response = await layer.queryFeatures(query);
   //       if (!response.features.length) {
   //          toast.error("No search found in Ulbs");
   //          // setBufferFeatures([]);
   //          setSelectedLayer("")
   //          return;
   //       }

   //       // Extract fields from the first feature's attributes
   //       const fields = response.fields?.map((field) => field.name) || [];
   //       // const fieldsFilter = fields.filter(fields => ['name', 'relation_id'].includes(fields))

   //       setFields(fields);

   //       // Convert feature geometries to serializable format
   //       const features = response.features.map((feature) => ({
   //          attributes: feature.attributes,
   //          geometry: feature.geometry ? feature.geometry.toJSON() : null,
   //       }));

   //       // Update buffer features
   //       // setBufferFeatures(response.features);

   //       response.features.forEach((feature) => {
   //          if (!feature.geometry) return;

   //          let graphic;
   //          const geometryType = feature.geometry.type;

   //          if (geometryType === "point") {
   //             graphic = new Graphic({
   //                geometry: feature.geometry,
   //                symbol: {
   //                   type: "simple-marker",
   //                   style: "circle",
   //                   color: [0, 0, 255, 0.5], // Blue with transparency
   //                   size: 6,
   //                   outline: { color: [0, 0, 255], width: 1 },
   //                },
   //             });
   //          } else if (["polyline", "multiline", "multipolyline"].includes(geometryType)) {
   //             graphic = new Graphic({
   //                geometry: feature.geometry,
   //                symbol: { type: "simple-line", color: [0, 255, 0], width: 2 }, // Green
   //             });
   //          } else if (["polygon", "multipolygon"].includes(geometryType)) {
   //             graphic = new Graphic({
   //                geometry: feature.geometry,
   //                symbol: {
   //                   type: "simple-fill",
   //                   color: [255, 255, 0, 0.5], // Yellow with transparency
   //                   outline: { color: [255, 255, 0], width: 1 },
   //                },
   //             });
   //          } else {
   //             console.log(`Unsupported geometry type: ${geometryType}`);
   //             return;
   //          }

   //          view.graphics.add(graphic);
   //       });

   //       // Zoom to the first feature's centroid
   //       const firstFeature = response.features[0];
   //       if (firstFeature.geometry) {
   //          const center = firstFeature.geometry.centroid || firstFeature.geometry.extent?.center;
   //          if (center) {
   //             view.goTo(center);
   //          } else {
   //             console.log("Center is null or undefined.");
   //          }
   //       }
   //    } catch (error) {
   //       console.log("Error fetching or processing layer data:", error);
   //    }
   // };

   const handleLayerChange = async (selectedOption) => {
      try {
         view.graphics.removeAll();
         const selected = selectedOption?.label;
         setSelectedLayer(selected);
         setSelectedField("");
         setFields([]);
         setSelectedFieldValue("");
         setFieldValues([]);
         const layerDetails = layers.find((layer) => layer.name === selected);
         if (!layerDetails) {
            console.log("Layer details not found for the selected option.");
            return;
         }

         // Updated URL construction based on service
         const baseUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/${layerDetails.service}`;
         const layerUrl = layerDetails.service === "urbangis_temp"
            ? `${baseUrl}/FeatureServer/${layerDetails.id}`
            : `${baseUrl}/MapServer/${layerDetails.id}`;

         const layer = new FeatureLayer({
            url: layerUrl,
         });

         // Rest of the function remains the same...
         const query = new Query();
         query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}'`;
         query.returnGeometry = true;
         query.outFields = ["*"];

         const response = await layer.queryFeatures(query);
         // ... rest of the function

         if (!response.features.length) {
            toast.error("No search found in Ulbs");
            // setBufferFeatures([]);
            setSelectedLayer("")
            return;
         }

         // Extract fields from the first feature's attributes
         const fields = response.fields?.map((field) => field.name) || [];
         // const fieldsFilter = fields.filter(fields => ['name', 'relation_id'].includes(fields))

         setFields(fields);

         // Convert feature geometries to serializable format
         const features = response.features.map((feature) => ({
            attributes: feature.attributes,
            geometry: feature.geometry ? feature.geometry.toJSON() : null,
         }));

         // Update buffer features
         // setBufferFeatures(response.features);

         response.features.forEach((feature) => {
            if (!feature.geometry) return;

            let graphic;
            const geometryType = feature.geometry.type;

            if (geometryType === "point") {
               graphic = new Graphic({
                  geometry: feature.geometry,
                  symbol: {
                     type: "simple-marker",
                     style: "circle",
                     color: [0, 0, 255, 0.5], // Blue with transparency
                     size: 6,
                     outline: { color: [0, 0, 255], width: 1 },
                  },
               });
            } else if (["polyline", "multiline", "multipolyline"].includes(geometryType)) {
               graphic = new Graphic({
                  geometry: feature.geometry,
                  symbol: { type: "simple-line", color: [0, 255, 0], width: 2 }, // Green
               });
            } else if (["polygon", "multipolygon"].includes(geometryType)) {
               graphic = new Graphic({
                  geometry: feature.geometry,
                  symbol: {
                     type: "simple-fill",
                     color: null, // Hollow fill
                     outline: { color: [101, 67, 33], width: 1 }, // Dark brown outline
                  },
               });
            } else {
               console.log(`Unsupported geometry type: ${geometryType}`);
               return;
            }

            view.graphics.add(graphic);
         });

         // Zoom to the first feature's centroid
         const firstFeature = response.features[0];
         if (firstFeature.geometry) {
            const center = firstFeature.geometry.centroid || firstFeature.geometry.extent?.center;
            if (center) {
               view.goTo(center);
            } else {
               console.log("Center is null or undefined.");
            }
         }



      } catch (error) {
         console.log("Error fetching or processing layer data:", error);
      }
   };
   // const handleFieldChange = async (option) => {
   //    try {
   //       const selectedField = option?.label;
   //       if (!selectedField) return;

   //       const layerDetails = layers.find((layer) => layer.name === selectedLayer);
   //       if (!layerDetails) {
   //          console.log("Layer details not found for selected layer:", selectedLayer);
   //          return;
   //       }

   //       const layer = new FeatureLayer({
   //          url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
   //       });

   //       const query = new Query();
   //       query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${selectedField} <> ' '`;
   //       query.returnDistinctValues = true;
   //       query.outFields = [selectedField];

   //       const response = await layer.queryFeatures(query);

   //       const values = response?.features?.map((feature) => feature?.attributes?.[selectedField]) || [];

   //       setFieldValues(values);
   //       setSelectedField(selectedField);
   //    } catch (error) {
   //       console.log("Error handling field change:", error);
   //    }
   // };

   const highlightFeatures = (features) => {
      view.graphics.removeAll(); // Clear previous highlights

      if (!features || features.length === 0) {
         console.log("No features found to highlight.");
         return;
      }

      features.forEach((feature) => {
         if (!feature.geometry) {
            console.log("Feature has no geometry:", feature);
            return;
         }

         let highlightGraphic;
         const geometryType = feature.geometry.type;

         if (geometryType === "point") {
            highlightGraphic = new Graphic({
               geometry: feature.geometry,
               symbol: {
                  type: "simple-marker",
                  style: "circle",
                  color: [255, 0, 0, 0.5], // Red with transparency
                  size: 8,
                  outline: { color: [255, 0, 0], width: 2 },
               },
            });
         } else if (geometryType === "polyline") {
            highlightGraphic = new Graphic({
               geometry: feature.geometry,
               symbol: {
                  type: "simple-line",
                  color: [255, 0, 0], // Red
                  width: 3,
               },
            });
         } else if (geometryType === "polygon") {
            highlightGraphic = new Graphic({
               geometry: feature.geometry,
               symbol: {
                  type: "simple-fill",
                  color: [255, 0, 0, 0.3], // Red with transparency
                  outline: { color: [255, 0, 0], width: 2 },
               },
            });
         } else {
            console.log(`Unsupported geometry type: ${geometryType}`);
            return;
         }

         view.graphics.add(highlightGraphic);
      });

      // Zoom to highlighted features
      if (features[0]?.geometry) {
         view.goTo(features.map((feature) => feature.geometry?.extent?.expand(1.5))).catch(err => console.log("Error zooming:", err));
      }
   };

   const handleFieldChange = async (option) => {
      try {
         const selectedField = option?.label;
         if (!selectedField) return;

         const layerDetails = layers.find((layer) => layer.name === selectedLayer);
         if (!layerDetails) {
            console.log("Layer details not found for selected layer:", selectedLayer);
            return;
         }

         // Updated URL construction based on service
         const baseUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/${layerDetails.service}`;
         const layerUrl = layerDetails.service === "urbangis_temp"
            ? `${baseUrl}/FeatureServer/${layerDetails.id}`
            : `${baseUrl}/MapServer/${layerDetails.id}`;

         const layer = new FeatureLayer({
            url: layerUrl,
         });

         const query = new Query();
         query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${selectedField} <> ' '`;
         query.returnDistinctValues = true;
         query.outFields = [selectedField];

         const response = await layer.queryFeatures(query);

         const values = response?.features?.map((feature) => feature?.attributes?.[selectedField]) || [];

         console.log("fieldValues1111111:", values);

         setFieldValues(values);
         setSelectedField(selectedField);



         // Rest of the function remains the same...
      } catch (error) {
         console.log("Error handling field change:", error);
      }
   };


   // const handleFieldValueChange = async (value) => {
   //    const selectedValue = value?.label;
   //    if (!selectedValue) return;

   //    setSelectedFieldValue(selectedValue);

   //    const layerDetails = layers.find(layer => layer.name === selectedLayer);
   //    if (!layerDetails) return;

   //    const layer = new FeatureLayer({
   //       url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerDetails.id}`,
   //    });

   //    const query = new Query();
   //    query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${selectedField} = '${selectedValue}'`;
   //    query.returnGeometry = true;

   //    try {
   //       const response = await layer.queryFeatures(query);
   //       console.log("response.geometryType1111", response.geometryType);
   //       if (response.geometryType === "polyline") {
   //          let paths = [];
   //          response.features.forEach((featutre) => {
   //             featutre.geometry.paths.forEach((path) => {
   //                paths.push(path);
   //             });
   //          });

   //          var polyline = {
   //             type: "polyline",
   //             paths: paths,
   //             spatialReference: { wkid: 4326 }
   //          };
   //          var feature = new Graphic({
   //             geometry: polyline,
   //          });
   //          // setGeometory(polyline);
   //          // highlightFeatures([feature]);
   //       } else {
   //          // setGeometory(response.features[0].geometry);
   //          // highlightFeatures(response.features);
   //       }



   //    } catch (error) {
   //       console.log("Error querying features:", error);
   //    }
   // };



   // const handleFieldValueChange = async (value) => {
   //    const selectedValue = value?.label;
   //    if (!selectedValue) return;

   //    setSelectedFieldValue(selectedValue);

   //    const layerDetails = layers.find(layer => layer.name === selectedLayer);
   //    if (!layerDetails) return;

   //    // Updated URL construction based on service
   //    const baseUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/${layerDetails.service}`;
   //    const layerUrl = layerDetails.service === "urbangis_temp"
   //       ? `${baseUrl}/FeatureServer/${layerDetails.id}`
   //       : `${baseUrl}/MapServer/${layerDetails.id}`;

   //    const layer = new FeatureLayer({
   //       url: layerUrl,
   //    });


   //    const query = new Query();
   //    query.where = `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${selectedField} = '${selectedValue}'`;
   //    query.returnGeometry = true;

   //    try {
   //       const response = await layer.queryFeatures(query);
   //       console.log("response.geometryType1111", response.geometryType);
   //       if (response.geometryType === "polyline") {
   //          let paths = [];
   //          response.features.forEach((featutre) => {
   //             featutre.geometry.paths.forEach((path) => {
   //                paths.push(path);
   //             });
   //          });

   //          var polyline = {
   //             type: "polyline",
   //             paths: paths,
   //             spatialReference: { wkid: 4326 }
   //          };
   //          var feature = new Graphic({
   //             geometry: polyline,
   //          });
   //          setGeometory(polyline);
   //          highlightFeatures([feature]);
   //       } else {
   //          setGeometory(response.features[0].geometry);
   //          highlightFeatures(response.features);
   //       }



   //    } catch (error) {
   //       console.log("Error querying features:", error);
   //    }

   //    // Rest of the function remains the same...
   // };

   const zoomToFeature = async (value, fieldName, layerId) => {
      try {
         const layer = new FeatureLayer({
            url: `https://urbangis.mp.gov.in/server/rest/services/temp_n/urbangis_temp/FeatureServer/${layerId}`
         });

         const query = new Query();
         query.where = `${fieldName} = '${value}'`;
         query.returnGeometry = true;
         query.outFields = ["*"]; // Optional: useful if you want feature attributes

         const response = await layer.queryFeatures(query);
         const feature = response?.features?.[0];

         if (!feature?.geometry) {
            console.log(`No features found for ${fieldName}: ${value}`);
            return;
         }

         const graphic = new Graphic({
            geometry: feature.geometry,
            symbol: {
               type: "simple-fill",
               color: null,
               outline: { color: [0, 0, 255], width: 2 }
            }
         });

         view?.graphics?.add(graphic);

         // Handle zoom logic based on geometry type
         if (feature.geometry.type === "point") {
            await view.goTo({
               target: feature.geometry,
               zoom: 17 // You can adjust this zoom level as needed
            });
         } else {
            const extent = feature.geometry.extent || feature.geometry;
            await view.goTo({
               target: extent.expand(1.5) // Optionally buffer the extent a bit
            });
         }
         // Handle zoom logic based on geometry type
         if (feature.geometry.type === "point") {
            await view.goTo({
               target: feature.geometry,
               zoom: 17 // You can adjust this zoom level as needed
            });
         } else {
            const extent = feature.geometry.extent || feature.geometry;
            await view.goTo({
               target: extent.expand(1.5) // Optionally buffer the extent a bit
            });
         }

      } catch (error) {
         console.log(`Error zooming to feature: ${value}`, error);
      }
   };


   const handlePlotSizeConditionChange = async (selectedOption, isValueChange = false) => {
      try {
         setIsSetLoader(true);

         // Update the appropriate state based on which dropdown changed
         if (isValueChange) {
            setSelectedPlotSizeValue(selectedOption);
         } else {
            setSelectedOperator(selectedOption);
         }

         // If either operator or value is missing, don't proceed with the query
         if (!selectedOperator || !selectedPlotSizeValue) {
            setIsSetLoader(false);
            return;
         }

         // Initialize graphics layer
         let graphicsLayer = plotSizeGraphicsLayer;
         if (!graphicsLayer) {
            graphicsLayer = new GraphicsLayer();
            view.map.add(graphicsLayer);
            setPlotSizeGraphicsLayer(graphicsLayer);
         } else {
            graphicsLayer.removeAll();
         }

         // Get layer details
         const layerDetails = layers.find(layer => layer.name === selectedLayer);
         if (!layerDetails) {
            toast.error("Selected layer not found");
            setIsSetLoader(false);
            return;
         }

         // Construct layer URL
         const baseUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/${layerDetails.service}`;
         const layerUrl = layerDetails.service === "urbangis_temp"
            ? `${baseUrl}/FeatureServer/${layerDetails.id}`
            : `${baseUrl}/MapServer/${layerDetails.id}`;

         const layer = new FeatureLayer({
            url: layerUrl,
         });

         // Build query condition based on selected operator and value
         let queryCondition;
         const plotSizeValue = selectedPlotSizeValue.value;

         switch (selectedOperator.value) {
            case 'gt':
               queryCondition = `CAST(${selectedField} AS FLOAT) > ${plotSizeValue}`;
               break;
            case 'eq':
               queryCondition = `CAST(${selectedField} AS FLOAT) = ${plotSizeValue}`;
               break;
            case 'lt':
               queryCondition = `CAST(${selectedField} AS FLOAT) < ${plotSizeValue}`;
               break;
            default:
               setIsSetLoader(false);
               return;
         }

         const query = new Query({
            where: `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${queryCondition}`,
            returnGeometry: true,
            outFields: ["*"],
            outSpatialReference: { wkid: 4326 }
         });

         const response = await layer.queryFeatures(query);

         if (!response.features || response.features.length === 0) {
            toast.info(`No properties found where plot size ${selectedOperator.label} ${plotSizeValue} sqm`);
            setIsSetLoader(false);
            return;
         }

         // Process features and add to graphics layer
         const validFeatures = response.features.filter(f => f.geometry);

         // alert(`Number of Property Found: ${validFeatures.length}`);
         setPlotCount(validFeatures.length)

         console.log("validFeaturesvalidFeatures", validFeatures.attributes)

         const extractedAttributes = [];
         validFeatures.forEach(feature => {
            const attributes = feature.attributes;
            console.log("attributes", attributes);
            extractedAttributes.push(attributes);
            // console.log(`e_nagarpalikaid: ${attributes.e_nagarpalikaid}\ndivisionname: ${attributes.divisionname}`);


            const geometryType = feature.geometry.type.toLowerCase();
            let symbol;

            if (geometryType.includes("point")) {
               symbol = {
                  type: "simple-marker",
                  style: "circle",
                  color: [0, 100, 0, 0.8],
                  size: 8,
                  outline: { color: [0, 50, 0], width: 1 },
               };
            } else if (geometryType.includes("polygon")) {
               symbol = {
                  type: "simple-fill",
                  color: [0, 100, 0, 0.5],
                  outline: { color: [0, 50, 0], width: 2 },
               };
            }

            if (symbol) {
               graphicsLayer.add(new Graphic({
                  geometry: feature.geometry,
                  symbol: symbol,
                  attributes: feature.attributes,
                  popupTemplate: {
                     title: "Property Details",
                     content: [{
                        type: "fields",
                        fieldInfos: [
                           { fieldName: "plotsize", label: "Plot Size (sqm)" },
                           { fieldName: "dist_cd", label: "District Code" },
                           { fieldName: "ulb_cd", label: "ULB Code" }
                        ]
                     }]
                  }
               }));
            }
         });
         setPlotData(extractedAttributes)


         // Zoom to results
         if (validFeatures.length === 1) {
            await view.goTo(validFeatures[0].geometry);
         } else {
            const extents = validFeatures.map(f => f.geometry.extent);
            const fullExtent = extents.reduce((a, b) => a.union(b));
            await view.goTo(fullExtent.expand(1.2));
         }

         setIsSetLoader(false);

      } catch (error) {
         console.error("Error in plot size query:", error);
         toast.error("An error occurred while querying plot sizes");
         setIsSetLoader(false);
      }
   };

   const handleFloorConditionChange = async (selectedOption) => {
      try {
         setIsSetLoader(true);
         setSelectedFloorCondition(selectedOption);

         if (!selectedOption || !selectedField || !selectedLayer || !selectedDistrict || !selectedUlb || !view) {
            toast.error("Missing required parameters");
            setIsSetLoader(false);
            return;
         }

         // Initialize or get graphics layer
         let graphicsLayer = plotSizeGraphicsLayer;
         if (!graphicsLayer) {
            graphicsLayer = new GraphicsLayer();
            view.map.add(graphicsLayer);
            setPlotSizeGraphicsLayer(graphicsLayer);
         } else {
            graphicsLayer.removeAll();
         }

         const layerDetails = layers.find(layer => layer.name === selectedLayer);
         if (!layerDetails) {
            toast.error("Selected layer not found");
            setIsSetLoader(false);
            return;
         }

         // Construct layer URL
         const baseUrl = `https://urbangis.mp.gov.in/server/rest/services/temp_n/${layerDetails.service}`;
         const layerUrl = layerDetails.service === "urbangis_temp"
            ? `${baseUrl}/FeatureServer/${layerDetails.id}`
            : `${baseUrl}/MapServer/${layerDetails.id}`;

         const layer = new FeatureLayer({
            url: layerUrl,
         });

         // Map dropdown values to query conditions
         let queryCondition;
         switch (selectedOption.value) {
            case 'G':
               queryCondition = "nooffloor = 'G'";
               break;
            case 'G+1':
               queryCondition = "nooffloor = 'G+1'";
               break;
            case 'G+2':
               queryCondition = "nooffloor = 'G+2'";
               break;
            case 'G+3':
               queryCondition = "nooffloor = 'G+3'";
               break;
            case 'Open':
               queryCondition = "nooffloor = 'Open'";
               break;
            case 'UC':
               queryCondition = "nooffloor = 'UC'";
               break;
            default:
               setIsSetLoader(false);
               return;
         }

         const query = new Query({
            where: `dist_cd = '${selectedDistrict}' AND ulb_cd = '${selectedUlb}' AND ${queryCondition}`,
            returnGeometry: true,
            outFields: ["*"],
            outSpatialReference: { wkid: 4326 }
         });

         let response;
         try {
            response = await layer.queryFeatures(query);

            console.log("response1111111", response.features);

            // Process features and add to graphics layer
            const validFeatures = response.features.filter(f => f.geometry);

            // alert(`Number of Property Found: ${validFeatures.length}`);
            setFloorCount(validFeatures.length)

            console.log("validFeaturesvalidFeatures_Floor", validFeatures.attributes)

            //length
            console.log("validFeaturesvalidFeatures_Floor", validFeatures.length)

            setPlotCount(validFeatures.length);

            const extractedAttributes = [];
            validFeatures.forEach(feature => {
               const attributes = feature.attributes;
               console.log("attributes", attributes);
               extractedAttributes.push(attributes);

               console.log(`e_nagarpalikaid: ${attributes.e_nagarpalikaid}\n
                               divisionname: ${attributes.divisionname}\n
                               Mobile No: ${attributes.mobile_no}\n
                               nooffloor: ${attributes.nooffloor}\n
                               Owner Name: ${attributes.ownername}\n`);


               const geometryType = feature.geometry.type.toLowerCase();
               let symbol;

               if (geometryType.includes("point")) {
                  symbol = {
                     type: "simple-marker",
                     style: "circle",
                     color: [0, 100, 0, 0.8],
                     size: 8,
                     outline: { color: [0, 50, 0], width: 1 },
                  };
               } else if (geometryType.includes("polygon")) {
                  symbol = {
                     type: "simple-fill",
                     color: [0, 100, 0, 0.5],
                     outline: { color: [0, 50, 0], width: 2 },
                  };
               }

               if (symbol) {
                  graphicsLayer.add(new Graphic({
                     geometry: feature.geometry,
                     symbol: symbol,
                     attributes: feature.attributes,
                     popupTemplate: {
                        title: "Property Details",
                        content: [{
                           type: "fields",
                           fieldInfos: [
                              { fieldName: "plotsize", label: "Plot Size (sqm)" },
                              { fieldName: "dist_cd", label: "District Code" },
                              { fieldName: "ulb_cd", label: "ULB Code" }
                           ]
                        }]
                     }
                  }));
               }
            });
            setFloorData(extractedAttributes)




            if (!response?.features) {
               throw new Error("Invalid response from server");
            }
         } catch (error) {
            console.error("Query error:", error);
            toast.error("Failed to query floor data");
            setIsSetLoader(false);
            return;
         }

         if (response.features.length === 0) {
            toast.info(`No properties found with ${selectedOption.label} floors`);
            setIsSetLoader(false);
            return;
         }

         // Process features
         const validFeatures = response.features.filter(f => f.geometry);
         if (validFeatures.length === 0) {
            toast.warning("No features with valid geometry found");
            setIsSetLoader(false);
            return;
         }

         // Create graphics
         validFeatures.forEach(feature => {
            try {
               const geometryType = feature.geometry.type.toLowerCase();
               let symbol;

               if (geometryType.includes("point")) {
                  symbol = {
                     type: "simple-marker",
                     style: "circle",
                     color: [70, 130, 180, 0.8], // Steel blue
                     size: 8,
                     outline: { color: [0, 0, 139], width: 1 }, // Dark blue
                  };
               } else if (geometryType.includes("line")) {
                  symbol = {
                     type: "simple-line",
                     color: [70, 130, 180], // Steel blue
                     width: 3,
                  };
               } else if (geometryType.includes("polygon")) {
                  symbol = {
                     type: "simple-fill",
                     color: [70, 130, 180, 0.5], // Steel blue with transparency
                     outline: { color: [0, 0, 139], width: 2 }, // Dark blue
                  };
               }

               if (symbol) {
                  graphicsLayer.add(new Graphic({
                     geometry: feature.geometry,
                     symbol: symbol,
                     attributes: feature.attributes,
                     popupTemplate: {
                        title: "Property Details",
                        content: [{
                           type: "fields",
                           fieldInfos: [
                              { fieldName: "nooffloor", label: "Number of Floors" },
                              { fieldName: "plotsize", label: "Plot Size (sqm)" },
                              { fieldName: "dist_cd", label: "District Code" }
                           ]
                        }]
                     }
                  }));
               }
            } catch (e) {
               console.warn("Error creating graphic for feature:", e);
            }
         });

         // Zoom to features
         try {
            if (validFeatures.length === 1) {
               await view.goTo(validFeatures[0].geometry);
            } else {
               const extents = validFeatures.map(f => f.geometry.extent);
               const fullExtent = extents.reduce((a, b) => a.union(b));
               await view.goTo(fullExtent.expand(1.2));
            }
         } catch (zoomError) {
            console.warn("Zoom error:", zoomError);
         }

         setIsSetLoader(false);

      } catch (error) {
         console.error("Unexpected error:", error);
         toast.error("An unexpected error occurred");
         setIsSetLoader(false);
      }
   };

   //console("SafloorData", floorData);


   const handleRefresh = () => {
      setDistrictName('')
      setUlbName('');
      setPlotCount('')
      setPlotData([])
      setFieldValues([])
      setSelectedField('')
      view.goTo({
         center: [78.746567, 23.83403], // Longitude, Latitude
         zoom: 7 // Adjust zoom level as needed
      });
   }

   const customStyles = {
      control: (provided, state) => ({
         ...provided,
         boxShadow: state.isFocused && !state.hasValue ? "0 0 0 1px #ccc" : "none",
         borderColor: state.isFocused && !state.hasValue ? "#ccc" : "#ccc",
         "&:hover": {
            borderColor: "#ccc",
         },
         fontSize: "12px",
      }),
      option: (provided, state) => ({
         ...provided,
         backgroundColor: state.isSelected
            ? "#d1ede9"
            : state.isFocused
               ? "#d1ede9"
               : "#FFFFFF",
         color: "#000",
         fontSize: "12px",
         padding: "10px",
      }),
      singleValue: (provided) => ({
         ...provided,
         color: "#000",
         fontSize: "12px",
      }),
      placeholder: (base) => ({
         ...base,
         color: "#000",
         fontSize: "12px",
      }),
      input: (provided) => ({
         ...provided,
         color: "#000",
         fontSize: "12px",
      }),
   };

   return (
      <div>
         <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
         />
         <Loader isLoader={isLoader} />
         <div className='tooltitlediv linear-gradian-bg'>
            <h6 className='tools-title text-white m-0'>GIS Query</h6>
         </div>

         {/* <div className="tabs-container d-flex justify-content-between mt-2 mb-2">
            <button className={`tab-btn ${activeSelect === "area" ? "active" : ""}`} onClick={() => setActiveSelect("area")}>Select Area</button>
            <button className={`tab-btn ${activeSelect === "layer" ? "active" : ""}`} onClick={() => setActiveSelect("layer")} >Layer</button>
         </div> */}


         {activeSelect == "layer" ? <>
            <div className="card shadow-sm p-3 mt-2">
               <h6 className="fw-bold mb-3">Layers</h6>

               {/* Search Box */}
               <div className="mb-3 position-relative">
                  <input
                     type="text"
                     className="form-control form-control-sm"
                     placeholder="Search"
                     value={search}
                     onChange={(e) => setSearch(e.target.value)}
                  />
                  {search && (
                     <button
                        className="btn btn-sm btn-link position-absolute end-0 top-0 mt-1 me-1"
                        onClick={() => setSearch("")}
                     >
                        ✕
                     </button>
                  )}
               </div>

               {/* Layers List */}
               <div>
                  {filteredLayers.map((layer) => (
                     <div
                        key={layer}
                        className="d-flex align-items-center justify-content-between py-2 border-bottom"
                     >
                        <div className="d-flex align-items-center gap-2">
                           <input
                              type="checkbox"
                              className="form-check-input"
                              checked={checked[layer] || false}
                              onChange={() => toggleCheck(layer)}
                           />
                           <span>{layer}</span>
                        </div>
                        <button
                           className="btn btn-sm p-0 border-0 bg-transparent"
                           onClick={() => toggleExpand(layer)}
                        >
                           {expanded[layer] ? <FaChevronUp /> : <FaChevronDown />}
                        </button>
                     </div>
                  ))}
               </div>
            </div>

         </> : <>

            <div className="mt-2">
               <label className="lebel-card-text">Select District</label>
               <Select
                  options={districts.map((district) => ({
                     value: district.id,
                     label: district.label,
                  }))}
                  value={districtName ? { label: districtName } : null}
                  onChange={(selectedOption) => {
                     if (!selectedOption) {
                        handleRefresh();
                     } else {
                        handleDistrictChange(selectedOption)
                     }
                  }
                  }
                  placeholder="Select District"
                  isClearable={true}
                  styles={customStyles}
                  // className="mt-2"
                  isDisabled={authData?.UserType === "User" || authData?.UserType === "districtuser"}
               />
            </div>

            {/* //select ulb  */}
            <div className="mt-2">
               <label className="lebel-card-text">Select Ulbs</label>
               <Select
                  options={ulbs.map((ulbs) => ({
                     value: ulbs.id,
                     label: ulbs.lable,
                  })).sort((a, b) => a.label.localeCompare(b.label))}
                  value={ulbName ? { label: ulbName } : null}
                  onChange={(selectedOption) => {
                     handleUlbChange(selectedOption)
                  }
                  }
                  placeholder="Select Ulbs"
                  isClearable={true}
                  styles={customStyles}
                  // className="mt-2"
                  // isDisabled={!districtName || authData?.UserRole === "Viewer"}
                  // isDisabled={!districtName || authData?.UserType === "User"}
                  isDisabled={authData?.UserType === "User" || authData?.UserType === "districtuser" || !districtName}
               />
            </div>

            {/* select layer  */}
            <div className="mt-2">
               <label className="lebel-card-text">Select layer</label>
               <Select
                  options={layers.map((layers) => ({
                     id: layers.id,
                     label: layers.name,
                  }))}
                  value={selectedLayer ? { label: selectedLayer } : null}
                  onChange={(selectedOption) =>
                     handleLayerChange(selectedOption)
                  }
                  placeholder="Select layer"
                  isClearable={true}
                  styles={customStyles}
                  isDisabled={!ulbName}
               // className="mt-2"
               />
            </div>
            <div className="mt-1 text-sm text-gray-600">
               <strong>where</strong>
            </div>

            {/* select field */}

            <Select
               options={fields
                  ?.filter(field => ['name', 'plotsize', 'nooffloor'].includes(field))
                  //?.filter(field => ['name', 'plotsize','nooffloor'].includes(field))
                  .map(field => ({ value: field, label: field }))} // Ensure proper format
               value={selectedField ? { label: selectedField } : null}
               onChange={(selectedOption) => handleFieldChange(selectedOption)}
               placeholder="Select Field"
               isClearable={true}
               styles={customStyles}
               isDisabled={!selectedLayer}
               className="mt-2"
            />

            {/* select field value */}
            {console.log("fieldValues:", fieldValues)}

            {/*
         <Select
            options={fieldValues.map((layers) => ({
               label: layers
            }))}
            value={selectedFieldValue ? { label: selectedFieldValue } : null}
            onChange={(selectedOption) =>
               handleFieldValueChange(selectedOption)
            }
            placeholder="Select Field Value"
            isClearable={true}
            isDisabled={!selectedField}
            // styles={customStyles}
            className="mt-2"
         />
       */}

            {/* drop down operator */}

            {/* dropdown for plot size conditions */}

            {/* {selectedField === 'plotsize' && (
            <Select
               options={[
                  { value: 'eq_1000', label: 'plotsize = 1000 sqmt' },
                  { value: 'gt_1000', label: 'plotsize > 1000 sqmt' },
                  { value: 'lt_1000', label: 'plotsize < 1000 sqmt' }
               ]}
               value={selectedPlotSizeCondition}
               // onChange={(selectedOption) => handlePlotSizeConditionChange(selectedOption)}
               placeholder="Select Plot Size Condition"
               isClearable={true}
               className="mt-2"
            />
         )} */}




            {selectedField === 'plotsize' && (
               <div className="mt-2 space-y-2">
                  {/* Operator dropdown */}
                  <Select
                     options={[
                        { value: 'gt', label: '> (greater than)' },
                        { value: 'eq', label: '= (equal to)' },
                        { value: 'lt', label: '< (less than)' },
                     ]}
                     value={selectedOperator}
                     onChange={(selectedOption) => {
                        setSelectedOperator(selectedOption);
                     }}
                     styles={customStyles}
                     placeholder="Select Operator"
                     isClearable={true}
                  />


                  <CreatableSelect
                     isClearable
                     onChange={(selectedOption) => {
                        setSelectedPlotSizeValue(selectedOption);
                     }}
                     onCreateOption={(inputValue) => {
                        const newOption = {
                           value: parseFloat(inputValue),
                           label: `${inputValue} sqft`
                        };
                        setSelectedPlotSizeValue(newOption);
                     }}
                     options={[
                        { value: 500, label: '500 sqft' },
                        { value: 1000, label: '1000 sqft' },
                        { value: 1500, label: '1500 sqft' },
                        { value: 2000, label: '2000 sqft' },
                     ]}
                     className='mt-2'
                     value={selectedPlotSizeValue}
                     styles={customStyles}
                     placeholder="Select or type plot size"
                     formatCreateLabel={(inputValue) => `Use "${inputValue} sqft"`}
                     isValidNewOption={(inputValue) => {
                        // Validate that the input is a positive number
                        return /^\d*\.?\d+$/.test(inputValue) && parseFloat(inputValue) > 0;
                     }}
                  />

                  {/* Apply button - only shown when both values are selected */}
                  {(selectedOperator && selectedPlotSizeValue) && (
                     <button
                        className={!selectedPlotSizeValue ? "btn-comman btn-runtax comman-text" : "btn-adddestination"}
                        onClick={() => {
                           const condition = {
                              value: `${selectedOperator.value}_${selectedPlotSizeValue.value}`,
                              label: `${selectedOperator.label} ${selectedPlotSizeValue.label}`
                           };
                           handlePlotSizeConditionChange(condition);
                        }}
                        style={{
                           marginTop: "10px",
                           background: " linear-gradient(175deg, #292548 3.41%, #03856E 95.82%)",
                           // backgroundColor: isTheme === 'light' && "#1F509A",
                           color: isTheme === 'light' && selectedPlotSizeValue && "#FFF"
                        }}
                     >
                        Apply
                     </button>
                  )}
               </div>
            )}




            {/*  dropdown for no of floor conditions */}

            {selectedField === 'nooffloor' && (
               <Select
                  options={[
                     { value: 'G', label: 'G(Ground Floor)' },
                     { value: 'G+1', label: 'G+1(One Floor)' },
                     { value: 'G+2', label: 'G+2(Two Floors)' },
                     { value: 'G+3', label: 'G+3(Three Floors)' },
                     { value: 'Open', label: 'Open' },
                     { value: 'UC', label: 'UC(Under-Construction)' }
                  ]}
                  value={selectedFloorCondition}
                  onChange={handleFloorConditionChange}
                  placeholder="Select Floor Type"
                  isClearable={true}
                  className="mt-2"
               />
            )}

            {Object.keys(plotData).length > 0 ? (
               <div className="mt-2">
                  <h5 className="tools-title m-0 p-0">Number of Property Found : {plotCount}</h5>
                  <div className="row scroll-hidden"
                     style={{
                        maxHeight: '82vh',
                        overflowY: 'auto',
                     }}
                  >
                     {Object.values(plotData).map((item, index) => (
                        <div key={index} className="col-12 mb-3">
                           <div
                              className="mis-card h-100"
                              style={{
                                 backgroundColor: isTheme === 'light' ? 'rgb(245, 245, 245)' : '#1E4580'
                              }}
                           >
                              <div className={`d-flex flex-column justify-content-center ${isTheme === 'light' ? '' : 'mis-propertycard'}`}>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Serial Number</span> {index + 1}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>E-nagarpalika ID</span> {item.e_nagarpalikaid}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Division Name</span> {item.divisionname}
                                 </p>

                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Owner Name</span> {item.ownername}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Mobile Number</span> {item.mobileno}
                                 </p>
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            ) : (
               <p></p>
            )}

            {floorData.length > 0 ? (
               <div className="mt-2">
                  <h5 className="tools-title m-0 p-0">Number of Floors Found: {floorCount}</h5>
                  <div
                     className="row scroll-hidden"

                  >
                     {floorData.map((item, index) => (
                        <div key={index} className="col-12 mb-3">
                           <div
                              className="mis-card h-100"
                              style={{
                                 backgroundColor: isTheme === 'light' ? 'rgb(245, 245, 245)' : '#1E4580',
                              }}
                           >
                              <div className={`d-flex flex-column justify-content-center ${isTheme === 'light' ? '' : 'mis-propertycard'}`}>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Serial Number</span> {index + 1}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>E-nagarpalika ID</span> {item.e_nagarpalikaid}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Division Name</span> {item.divisionname}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Owner Name</span> {item.ownername}
                                 </p>
                                 <p className="propertyinfodiv d-flex justify-content-between">
                                    <span>Mobile Number</span> {item.mobileno || item.mobile_no}
                                 </p>
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>
               </div>
            ) : (
               <p></p>
            )}


         </>}
      </div>
   )
}

const CustomSelectMain = ({ options = [], optionPlaceholder, handleFieldValueChange, disabled }) => {
   const [isOpen, setIsOpen] = useState(false);
   const [selectedOption, setSelectedOption] = useState(null);
   const dropdownRef = useRef(null);
   const containerRef = useRef(null);
   const { isTheme } = useSelector((state) => state.currentStage)


   const selectStyles = {
      container: {
         position: 'relative',
         marginTop: '10px',
      },
      selectButton: {
         width: '100%',
         padding: '8px 12px',
         border: 'none',
         borderRadius: isOpen ? '4px 4px 0 0' : '4px',
         backgroundColor: isTheme === 'light' ? '#F5F5F5' : '#002864',
         cursor: 'pointer',
         display: 'flex',
         justifyContent: 'space-between',
         alignItems: 'center',
         fontSize: '14px',
         fontWeight: '500',
         color: isTheme === 'light' ? '#000000' : 'white'
      },
      dropdownContainer: {
         width: '100%',
         backgroundColor: '#002864',
         border: 'none',
         borderRadius: '0 0 4px 4px',
         color: 'white',
         boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      },
      option: {
         padding: '6px 12px',
         cursor: 'pointer',
         backgroundColor: '#002864',
         color: 'white',
         transition: 'background-color 0.2s ease',
         fontSize: '14px',
         fontWeight: "400",
         borderTop: "0.5px solid #0e0e0e",
         borderBottom: "0.5px solid #0e0e0e"
      }
   };

   useEffect(() => {
      const handleClickOutside = (event) => {
         if (containerRef.current && !containerRef.current.contains(event.target)) {
            setIsOpen(false);
         }
      };

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
   }, []);

   const handleSelect = (option) => {
      if (disabled) return;
      setSelectedOption(option);
      setIsOpen(false);
      handleFieldValueChange(option);
   };



   console.log("optionsoptions", options)



   return (
      <div style={selectStyles.container} ref={containerRef}>
         <div
            style={selectStyles.selectButton}
            onClick={() => !disabled && setIsOpen(!isOpen)}
         >
            <span
               style={{
                  color: disabled ? isTheme === 'light' ? '#7E7E7E' : "rgba(255, 255, 255, 0.75)" : isTheme === 'light' ? '#000000' : "white",
                  cursor: disabled ? "not-allowed" : "pointer",
               }}
            >{selectedOption ? selectedOption.lable || selectedOption.name : optionPlaceholder}</span>
            <span style={{
               transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
               transition: 'transform 0.2s ease'
            }}>▼</span>
         </div>

         {isOpen && !disabled && (
            <div style={selectStyles.dropdownContainer} ref={dropdownRef}>
               {options.map((option) => (
                  <div
                     key={option.id}
                     style={{
                        ...selectStyles.option,
                        backgroundColor: selectedOption?.id === option.id ? '#2465c6' : 'black'
                     }}
                     onClick={() => handleSelect(option)}
                     onMouseEnter={(e) => {
                        e.target.style.backgroundColor = '#2465c6';
                     }}
                     onMouseLeave={(e) => {
                        e.target.style.backgroundColor =
                           selectedOption?.id === option.id ? '#2465c6' : 'black';
                     }}
                  >
                     {option?.lable || option?.name}
                  </div>
               ))}
            </div>
         )}


      </div>
   );
};

export default GisQuery
